ProductReviews = window.ProductReviews ?= {}
ProductReviews.Views ?= {}
ProductReviews.Templates ?= {}

ProductReviews.Templates['product_reviews_stars'] = require '../../stars.html.mustache'

ProductReviews.Views.ReviewRating = Backbone.View.extend
  render: ->
    @$el.append ProductReviews.Templates['product_reviews_stars'].render(@model.attributes)


module.exports = ProductReviews.Views.ReviewRating
